import Form from './Form';
import Label from './Label';
import LoginForm from './LoginForm';
import SmsForm from './SmsForm';
import EmailForm from './EmailForm';
import FormError from './FormError';
import FormErrorInline from './FormErrorInline';
import PasswordResetForm, { getErrorMsg } from './PasswordResetForm';
import SignupForm from './SignupForm';

export default Form;
export {
  Label,
  LoginForm,
  SmsForm,
  EmailForm,
  FormError,
  FormErrorInline,
  PasswordResetForm,
  getErrorMsg,
  SignupForm,
};
